var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ibox"},[_c('ibox-title',[_vm._v("Обсуждение элемента")]),_c('div',{staticClass:"ibox-content"},[_c('channel-view',{attrs:{"channel":_vm.chatChannelKey,"hide-title":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }